import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ timeOutAfterSuccess }) => {
  return (
    <div className='w-full h-2 rounded-full overflow-hidden'>
      <motion.div
        className='h-full bg-ih-blue'
        initial={{ width: '0%' }}
        animate={{ width: '100%' }}
        transition={{ duration: timeOutAfterSuccess/1000, ease: 'linear' }}
      />
    </div>
  );
};

export default ProgressBar;
